import vSidebar from "./v-sidebar.vue";
import vSidebarItem from "./v-sidebar-item.vue";
import vSidebarLanguage from "./v-sidebar-language.vue";

export default Vue => {
  Vue.component("v-sidebar", vSidebar);
  Vue.component("v-sidebar-item", vSidebarItem);
  Vue.component("v-sidebar-language", vSidebarLanguage);
};
